<app-data-table mainTitle="Países"
                singleTitle="País"
                routerPath="/siscoserv/pais"
                entityPath="/tbcodpais"
                [entity]="tbCodPais"
                [columns]="this['columns']"
                [controls]="this['controls']">
</app-data-table>
